import { createContext } from 'react';

import type { PortalAuthContextValue } from './types';

export const PortalAuthContext = createContext<PortalAuthContextValue | null>(null);
